import React, { useEffect, useState } from 'react'
import useFetch from '../hooks/useFetch';
import { baseURL1, vehicleId } from '../utils/baseUrl';
import strings from '../utils/locals/languages';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Cookies from "js-cookie";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { handleCarClick } from "../methods/handlers";
import { useNavigate } from 'react-router-dom';
import FavoriteOutlinedIcon from "@mui/icons-material/FavoriteOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import apiClient from '../utils/apiClient';
import year from "../images/yeear.svg";
import engineSize from "../images/engine.svg";
import calendar from "../images/calendar.svg";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

const RecommendedVehicles = ({ searchText }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limit = 5;

    const { data, isLoading, refetch } = useFetch(
        `${baseURL1}/v1/adds/recommended?section=${vehicleId}&language=${strings._language}&page=${currentPage}&limit=${limit}`
    );

    const navigate = useNavigate()
    const user = Cookies.get("userDetails");
    const [userId, setUserId] = useState("");

    const renderPaginationButtons = () => {
        const pages = [];
        const maxDisplayed = 5;
        const halfMaxDisplayed = Math.floor(maxDisplayed / 2);

        if (totalPages <= maxDisplayed) {
            for (let i = 1; i <= totalPages; i++) pages.push(i);
        } else {
            if (currentPage <= halfMaxDisplayed + 1) {
                for (let i = 1; i <= maxDisplayed - 1; i++) pages.push(i);
                pages.push("...");
                pages.push(totalPages);
            } else if (currentPage >= totalPages - halfMaxDisplayed) {
                pages.push(1);
                pages.push("...");
                for (let i = totalPages - (maxDisplayed - 2); i <= totalPages; i++) pages.push(i);
            } else {
                pages.push(1);
                pages.push("...");
                for (let i = currentPage - 1; i <= currentPage + 1; i++) pages.push(i);
                pages.push("...");
                pages.push(totalPages);
            }
        }

        return pages.map((page, index) => {
            if (page === "...") {
                return <span key={index} className="mx-2 text-gray-500">...</span>;
            }
            return (
                <button
                    key={page}
                    className={`mx-1 px-3 py-1 rounded-full text-sm ${currentPage === page ? "bg-orange-500 text-white" : "bg-gray-200 text-gray-700"
                        }`}
                    onClick={() => setCurrentPage(page)}
                >
                    {page}
                </button>
            );
        });
    };

    useEffect(() => {
        if (data?.totalPages) {
            setTotalPages(data.totalPages);
        }
    }, [data]);

    const addToFavorites = async (event, adId) => {
        event.stopPropagation();
        try {
            await apiClient.get(`/v1/user/fav-unfav/${adId}`);
            refetch();
        } catch (error) {
            console.error("Error updating favorites:", error);
        }
    };

    useEffect(() => {
        const userDetails = Cookies.get("userDetails");
        if (userDetails) {
            const user = JSON?.parse(userDetails);
            setUserId(user._id);
        } else {
            setUserId("0");
        }
    }, []);

    return (
        <div className="mx-auto px-4 xl:px-0" >
            {isLoading ? (
                <div className="container">
                    <Skeleton height={30} width={350} className="mb-6" />
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                        {[...Array(limit)].map((_, index) => (
                            <div key={index} className="shadow-xl rounded-xl overflow-hidden">
                                <Skeleton height={160} className="rounded-t-xl" />
                                <div className="px-[10px] mt-2">
                                    <div className="flex justify-between">
                                        <Skeleton width={70} height={15} />
                                        <Skeleton width={50} height={15} />
                                    </div>
                                    <Skeleton width={100} height={10} className="mt-2" />
                                    <div className="flex justify-between my-2">
                                        <Skeleton width={60} height={10} />
                                        <Skeleton width={60} height={10} />
                                        <Skeleton width={60} height={10} />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <div className="container">
                    <h4 className="uppercase font-semibold text-[20px] mb-4">
                        {strings.recommendedVehicles}
                    </h4>

                    {data.data.length === 0 ? (
                        <div className="flex justify-center py-8">
                            <h3>{strings.norec}</h3>
                        </div>
                    ) : (
                        <>
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                                {
                                    data.data
                                        .filter(ad => {
                                            if (!searchText) return true;
                                            const lowerSearch = searchText.toLowerCase();

                                            const titleMatch = ad.basicInformation.title?.toLowerCase().includes(lowerSearch);
                                            const descMatch = ad.basicInformation.description?.toLowerCase().includes(lowerSearch);

                                            const brandMatch = ad.basicInformation.brand?.sub_category?.some(sub =>
                                                sub.title.toLowerCase().includes(lowerSearch)
                                            );

                                            const categoryMatch = ad.basicInformation.category?.category?.some(cat =>
                                                cat.title.toLowerCase().includes(lowerSearch)
                                            );

                                            return titleMatch || descMatch || brandMatch || categoryMatch;
                                        })
                                        .map((item, index) => (
                                            <div
                                                key={item._id}
                                                className="relative shadow-md rounded-xl cursor-pointer hover:shadow-lg transition-shadow duration-200"
                                                onClick={() => handleCarClick(navigate, item._id, item.basicInformation.title, item.basicInformation.category.title, item.basicInformation.brand.title, item.basicInformation.model.title, item.location.city, item.location.district, item.basicInformation.KM)}
                                            >
                                                <div className="relative h-40 w-full">
                                                    {!item?.fav?.includes(userId) ? (
                                                        <FavoriteBorderOutlinedIcon
                                                            className="absolute top-2 right-2 z-10"
                                                            style={{
                                                                color: "#F37521",
                                                                backgroundColor: "white",
                                                                borderRadius: "100%",
                                                                padding: 3,
                                                                fontSize: "28px"
                                                            }}
                                                            onClick={(event) => user && addToFavorites(event, item._id)}
                                                        />
                                                    ) : (
                                                        <FavoriteOutlinedIcon
                                                            className="absolute top-2 right-2 z-10"
                                                            style={{
                                                                color: "red",
                                                                backgroundColor: "white",
                                                                borderRadius: "100%",
                                                                padding: 3,
                                                                fontSize: "28px"
                                                            }}
                                                            onClick={(event) => user && addToFavorites(event, item._id)}
                                                        />
                                                    )}
                                                    <img
                                                        className="w-full h-full object-cover rounded-t-xl"
                                                        src={item.coverPhoto || item.imageUrl[0]}
                                                        alt="vehicle"
                                                    />
                                                </div>

                                                <div className="px-3 pt-2 pb-3">
                                                    <div className="flex justify-between items-center">
                                                        <h3 className="font-medium text-sm truncate">
                                                            {item.basicInformation.title}
                                                        </h3>
                                                        <div className="flex items-center text-[#F37521] ml-2">
                                                            <span className="font-bold text-sm whitespace-nowrap">
                                                                {item?.basicInformation?.price?.currency}&nbsp;
                                                                {Number(item?.basicInformation?.price?.price).toLocaleString()}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <p className="text-[9px] font-light text-gray-400 mt-1 truncate">
                                                        {item.basicInformation.description?.slice(0, 25)}
                                                    </p>

                                                    <div className="flex justify-between items-center text-[10px] text-gray-400 mt-2">
                                                        <div className="flex items-center gap-1">
                                                            <img src={year} alt="year" className="h-3 w-3" />
                                                            <span>{item?.basicInformation?.details[0]?.value}</span>
                                                        </div>
                                                        <div className="flex items-center gap-1">
                                                            <img src={engineSize} alt="engine" className="h-3 w-3" />
                                                            <span>
                                                                {item.basicInformation.details
                                                                    .find(d => ["Engine Size", "Размер двигателя", "Dvigatel hajmi"]
                                                                        .includes(d.fieldName))?.value}
                                                            </span>
                                                        </div>
                                                        <div className="flex items-center gap-1">
                                                            <img src={calendar} alt="km" className="h-3 w-3" />
                                                            <span>{item.basicInformation.KM}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                            </div>

                            <div className="flex justify-center items-center mt-6 gap-1">
                                <button
                                    className={`p-2 rounded-full ${currentPage === 1 ? 'bg-gray-200 cursor-not-allowed' : 'bg-gray-200 hover:bg-gray-300'}`}
                                    onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                                    disabled={currentPage === 1}
                                >
                                    <ArrowBackIosIcon style={{ fontSize: '16px' }} />
                                </button>

                                {renderPaginationButtons()}

                                <button
                                    className={`p-2 rounded-full ${currentPage === totalPages ? 'bg-gray-200 cursor-not-allowed' : 'bg-gray-200 hover:bg-gray-300'}`}
                                    onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                                    disabled={currentPage === totalPages}
                                >
                                    <ArrowForwardIosIcon style={{ fontSize: '16px' }} />
                                </button>
                            </div>
                        </>
                    )}
                </div>
            )
            }
        </div >
    )
}

export default RecommendedVehicles